//订单状态
let orderStatusMap = {
    waitPay: 101, //等待付款
    waitAudit: 102, //等待审核
    waitDelivery: 199, //等待发货
    waitTake: 449, //等待收货
    completeStatus: 501, //订单完成
    closeStatus: 601, //关闭状态
};

//订单汇款状态
let remittanceStatusMap = {
    waitAudit: 0, //等待审核
    auditSuccess: 1, // 审核成功
    auditFailure: -1, //审核失败
};

//订单加急状态
let orderUrgentStatusMap = {
    urgentWait: 0,
    urgentSuccess: 1,
    urgentFailed: -1,
};

export { orderStatusMap, remittanceStatusMap, orderUrgentStatusMap };
